module.exports = __webpack_public_path__ + "img/OPENING.bb26e1fb.png";